import { render, staticRenderFns } from "./WorkbenchSidebar.vue?vue&type=template&id=1fd586c5&scoped=true&"
import script from "./WorkbenchSidebar.vue?vue&type=script&lang=js&"
export * from "./WorkbenchSidebar.vue?vue&type=script&lang=js&"
import style0 from "./WorkbenchSidebar.vue?vue&type=style&index=0&id=1fd586c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd586c5",
  null
  
)

export default component.exports